// utils/deleteEntity.js
import api from "../../axiosConfig";
import { toast } from "react-toastify";

export const deleteEntity = async ({
  endpoint,
  id,
  setState,
  itemName = "elementul",
  softDelete = false
}) => {
  const confirmText = `Sigur dorești să ștergi ${itemName} cu ID ${id}?`;
  if (!window.confirm(confirmText)) return;

  try {
    await api.delete(`/${endpoint}/${id}`);

    if (!softDelete) {
      setState((prev) => prev.filter((item) => item.id !== id));
    } else {
      setState((prev) =>
        prev.map((item) =>
          item.id === id ? { ...item, active: false } : item
        )
      );
    }

    toast.success(`${itemName.charAt(0).toUpperCase() + itemName.slice(1)} a fost șters cu succes.`);
  } catch (error) {
    console.error(`Eroare la ștergerea ${itemName}:`, error);
    toast.error(`A apărut o eroare la ștergerea ${itemName}.`);
  }
};
